import { render, staticRenderFns } from "./CompanyUploads.vue?vue&type=template&id=4080dce8&scoped=true"
import script from "./CompanyUploads.vue?vue&type=script&lang=js"
export * from "./CompanyUploads.vue?vue&type=script&lang=js"
import style0 from "./CompanyUploads.vue?vue&type=style&index=0&id=4080dce8&prod&scoped=true&lang=scss"
import style1 from "./CompanyUploads.vue?vue&type=style&index=1&id=4080dce8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4080dce8",
  null
  
)

export default component.exports